'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, FormProvider } from 'react-hook-form';

import type { FormProps } from './form.types';
import type { FieldValues } from 'react-hook-form';

const Form = <T extends FieldValues>({
  ariaLabel = 'form',
  children,
  onSubmit,
  schema,
  className,
  id,
  defaultValues,
}: FormProps<T>) => {
  const methods = useForm<T>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form
        id={id}
        className={className}
        aria-label={ariaLabel}
        onSubmit={(event) =>
          void methods.handleSubmit((data: T) =>
            onSubmit(data, methods.setError)
          )(event)
        }
      >
        {children}
      </form>
    </FormProvider>
  );
};

export { Form };
